import React, {useContext, FC} from 'react';

import {FormsFormTableContext} from '../form-table/form-table-context';
import {TABLE_ACTION_MAP} from './table-action-constants';
import {ITableActionProps} from './table-action-types';

import './table-action.less';

export const TableAction: FC<ITableActionProps> = (
    {
        meta, entityName, wrapper, url, parentEntityType, onClose, closeTableSubmenu, ...props
    }: ITableActionProps,
) => {
    const ActionComponent = TABLE_ACTION_MAP[meta.actionType];
    const {form} = useContext(FormsFormTableContext);
    const handleClick = form ? () => form?.resetFields() : undefined;

    return ActionComponent ? (
        <ActionComponent
            meta={meta}
            parentEntityType={parentEntityType}
            url={url}
            entityName={entityName}
            wrapper={wrapper}
            onClose={onClose}
            onClick={handleClick}
            buttonType={meta?.buttonType}
            closeTableSubmenu={closeTableSubmenu}
            {...props}
        />
    ) : null;
};
